require('./lbaCompanyReferenceCodeSelect.scss');

const $inject = [];

const lbaCompanyReferenceCodeSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaCompanyReferenceCodeSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaCompanyReferenceCodeSelect.html')
  }
};

lbaCompanyReferenceCodeSelect.$inject = $inject;

export default lbaCompanyReferenceCodeSelect;



// WEBPACK FOOTER //
// ./src/components/lbaCompanyReferenceCodeSelect/lbaCompanyReferenceCodeSelectDir.js